import { createSlice } from "@reduxjs/toolkit";
import { FlashbarProps } from "@cloudscape-design/components";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "src/core/redux";

interface IBreadCrumb {
    text: string
    href: string
}

interface IState {
    pageTitle: string;
    sideNavOpen: boolean;
    helpPanelOpen: boolean;
    infoMessages: FlashbarProps.MessageDefinition[];
}

const initialState: IState = {
    pageTitle: "Dependency Sentinel",
    sideNavOpen: false,
    helpPanelOpen: false,
    infoMessages: [],
};

export const uiSlice = createSlice({
    name: "ui.AppLayout",
    initialState,
    reducers: {
        setPageTitle: (state, action: PayloadAction<string>) => {
            state.pageTitle = action.payload;
        },
        setSideNavOpen: (state, action: PayloadAction<boolean>) => {
            state.sideNavOpen = action.payload;
        },
        setHelpPanelOpen: (state, action: PayloadAction<boolean>) => {
            state.helpPanelOpen = action.payload;
        },
        appendInfoMessage: (state, action: PayloadAction<FlashbarProps.MessageDefinition>) => {
            state.infoMessages.push(action.payload);
        },
        removeInfoMessage: (state, action: PayloadAction<FlashbarProps.MessageDefinition>) => {
            state.infoMessages = state.infoMessages.filter(msg => msg.id !== action.payload.id);
        }
    }
});

export const {
    setPageTitle,
    setSideNavOpen,
    setHelpPanelOpen,
    appendInfoMessage,
    removeInfoMessage
} = uiSlice.actions;

const selectAppLayout = (state: RootState) => state["ui.AppLayout"];
export const selectPageTitle = (state: RootState) => selectAppLayout(state).pageTitle;
export const selectSideNavOpen = (state: RootState) => selectAppLayout(state).sideNavOpen;
export const selectHelpPanelOpen = (state: RootState) => selectAppLayout(state).helpPanelOpen;
export const selectInfoMessages = (state: RootState) => selectAppLayout(state).infoMessages;

export default uiSlice.reducer;